<template>
  <el-main v-loading="loading">
    <!-- 搜索栏 -->
    <div class="search-box">
      <el-form :inline="true" :model="searchForm">
        <el-form-item label="分类类型">
          <el-select v-model="searchForm.type" placeholder="请选择分类类型">
            <el-option label="行业" :value="1"></el-option>
            <el-option label="产品" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类名称">
          <el-input v-model="searchForm.name" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 操作按钮 -->
    <div class="operation-box">
      <el-button type="primary" @click="handleAdd">新增分类</el-button>
    </div>

    <!-- 表格 -->
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="name" label="分类名称"></el-table-column>
      <el-table-column prop="type" label="分类类型">
        <template slot-scope="scope">
          {{ scope.row.type === 1 ? '行业' : '产品' }}
        </template>
      </el-table-column>
      <el-table-column prop="is_show" label="显示状态">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.is_show == 1"
            @change="handleStatusChange(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" class="delete-btn" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="分类类型" prop="type" v-if="!isEdit">
          <el-select v-model="form.type" placeholder="请选择分类类型">
            <el-option label="行业" :value="1"></el-option>
            <el-option label="产品" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="是否显示" prop="is_show">
          <el-switch @change="handleAddStatusChange" :value="form.is_show == 1"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
export default {
  name: 'storeMemberCategory',
  data() {
    return {
      loading: false,
      searchForm: {
        type: '',
        name: ''
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      form: {
        type: 1,
        name: '',
        is_show: 1,
        id: null
      },
      rules: {
        type: [{ required: true, message: '请选择分类类型', trigger: 'change' }],
        name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表数据
    async getList() {
      this.loading = true
      try {
        const res = await this.$axios.get('/Gateway/MemberCate/list', {
          params: {
            page: this.page,
            pageSize: this.pageSize,
            ...this.searchForm
          }
        })
        this.tableData = res.result.list
        this.total = res.result.total
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    },

    // 搜索
    handleSearch() {
      this.page = 1
      this.getList()
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        type: '',
        name: ''
      }
      this.handleSearch()
    },

    // 新增
    handleAdd() {
      this.isEdit = false
      this.dialogTitle = '新增分类'
      this.form = {
        type: 1,
        name: '',
        is_show: 1
      }
      this.dialogVisible = true
    },

    // 编辑
    handleEdit(row) {
      this.isEdit = true
      this.dialogTitle = '编辑分类'
      this.form = { ...row }
      this.dialogVisible = true
    },

    // 删除
    handleDelete(row) {
      this.$confirm('确认删除该分类?', '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          await this.$axios.post('/Gateway/MemberCate/del', { id: row.id })
          this.$message.success('删除成功')
          this.getList()
        } catch (error) {
          console.error(error)
        }
      }).catch(() => {})
    },

    // 提交表单
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const url = this.isEdit 
              ? '/Gateway/MemberCate/edit'
              : '/Gateway/MemberCate/add'
            await this.$axios.post(url, this.form)
            this.$message.success(this.isEdit ? '编辑成功' : '添加成功')
            this.dialogVisible = false
            this.getList()
          } catch (error) {
            console.error(error)
          }
        }
      })
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getList()
    },

    // 状态切换
    async handleStatusChange(row) {
      try {
        const newStatus = row.is_show == 1 ? 0 : 1
        await this.$axios.post('/Gateway/MemberCate/edit', {
          id: row.id,
          is_show: newStatus,
          type: row.type,
          name: row.name
        })
        this.$message.success('状态修改成功')
        this.getList()
      } catch (error) {
        row.is_show = row.is_show ? 0 : 1
        console.error(error)
      }
    },
    handleAddStatusChange(val) {
      this.form.is_show = val ? 1 : 0
    }
  }
}
</script>

<style lang="less" scoped>
.search-box {
  margin-bottom: 20px;
}
.operation-box {
  margin-bottom: 20px;
}
.pagination-box {
  margin-top: 20px;
  text-align: right;
}
.delete-btn {
  color: #F56C6C;
}
</style>